export enum RoleEnum {
    Peasant,
    Citizen,
    Doctor,
    Sheriff,
    BusDriver,
    Bodyguard,
    Veteran,
    Lookout,
    Detective,
    Vigilante,
    Escort,
    Investigator,
    Witness,
    Godfather,
    Mafioso,
    Agent,
    Framer,
    Seducer,
    Counselor,
    Consort,
    MassMurder,
    SerialKiller,
    Survivor,
    Jester,
    Executioner,
}

export const TOWN_ROLE_GROUPS: string[] = [
    'TownRandom', 'TownProtective', 'TownInvestigative', 'TownPower', 'TownKilling'
]

export const TOWN_ROLES: string[] = [
    'Citizen',
    'Peasant',
    'Doctor',
    'Sheriff',
    'BusDriver',
    'Bodyguard',
    'Veteran',
    'Lookout',
    'Detective',
    'Vigilante',
    'Escort',
    'Investigator',
    'Witness',
];

export const MAFIA_ROLE_GROUPS: string[] = [
    'MafiaRandom', 'MafiaSupport', 'MafiaDeception', 'MafiaKilling'
]

export const MAFIA_ROLES: string[] = [
    'Godfather',
    'Mafioso',
    'Agent',
    'Framer',
    'Seducer',
    'Counselor',
    'Consort',
];

export const NEUTRAL_ROLE_GROUPS: string[] = [
    'NeutralRandom', 'NeutralKilling', 'NeutralBenign'
]

export const NEUTRAL_ROLES: string[] = [
    'MassMurder',
    'SerialKiller',
    'Survivor',
    'Jester',
    'Executioner',
]